import React, { ReactElement } from 'react';
import './boxListItemComponent.scss';
import { Col, Row } from 'idsk-react-components';
import BoxListItemType from '../BoxListItemType';
import BoxListItemComponent from './BoxListItemComponent';

interface Props {
  itemList: BoxListItemType[];
}

const BoxListItemRow = ({
  itemList,
}: Props): ReactElement => (
  <Row>
    {itemList.map(item => (
      <Col key={`boxListColKey-${item.id}`} width="one-third">
        <BoxListItemComponent key={`boxListListItemComponentKey-${item.id}`} item={item} />
      </Col>
    ))}
  </Row>
);
export default BoxListItemRow;
